(function attachSantaBrisaMapCore(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else if (root) {
    root.SantaBrisaMap15Core = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function createSantaBrisaMapCore() {
  const allowedCategories = new Set(['restauracion', 'tienda']);

  function fold(value) {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/gu, '')
      .toLocaleLowerCase('es')
      .trim();
  }

  function normalizeVenues(rawVenues) {
    if (!Array.isArray(rawVenues)) return [];
    return rawVenues.flatMap((raw, index) => {
      const name = String(raw?.n ?? '').trim();
      const city = String(raw?.c ?? '').trim();
      const latitude = raw?.lat;
      const longitude = raw?.lng;
      const url = String(raw?.u ?? '').trim();
      const category = String(raw?.cat ?? '').trim();
      const valid = name && city
        && typeof latitude === 'number' && Number.isFinite(latitude) && latitude >= 27 && latitude <= 44
        && typeof longitude === 'number' && Number.isFinite(longitude) && longitude >= -19 && longitude <= 5
        && /^https:\/\/maps\.google\.com\//u.test(url) && allowedCategories.has(category);
      if (!valid) return [];
      return [{
        id: `sb15-venue-${index}`,
        name,
        city,
        latitude,
        longitude,
        url,
        category,
        searchable: fold(`${name} ${city}`),
      }];
    });
  }

  function filterVenues(venues, options = {}) {
    const list = Array.isArray(venues) ? venues : [];
    const safeOptions = options && typeof options === 'object' ? options : {};
    const { query = '', category = 'todos' } = safeOptions;
    const needle = fold(query);
    return list.filter((venue) => {
      const categoryMatches = category === 'todos' || venue.category === category;
      const queryMatches = !needle || venue.searchable.includes(needle);
      return categoryMatches && queryMatches;
    });
  }

  function countByCategory(venues) {
    const list = Array.isArray(venues) ? venues : [];
    return list.reduce((counts, venue) => {
      if (!allowedCategories.has(venue?.category)) return counts;
      counts.total += 1;
      counts[venue.category] += 1;
      return counts;
    }, { total: 0, restauracion: 0, tienda: 0 });
  }

  return { fold, normalizeVenues, filterVenues, countByCategory };
});
